import { render } from "./ImageUploader.vue?vue&type=template&id=c7d42652&scoped=true"
import script from "./ImageUploader.vue?vue&type=script&lang=js"
export * from "./ImageUploader.vue?vue&type=script&lang=js"

import "./ImageUploader.vue?vue&type=style&index=0&id=c7d42652&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7d42652"]])

export default __exports__